import React, { useRef } from 'react';

import ReactDOM from 'react-dom';

import { ReactComponent as CloseIcon } from '../../../../../assets/icons/v3/close.svg';
import useOutsideComponentClick from '../../../../hooks/useOutsideComponentClick/outsideComponentClick';
import { IGenericSidebar } from '../../../../interfaces/global';
import './GenericSideBar.scss';

const GenericSidebar = ({
  children,
  isOpen,
  position,
  onClose,
  removePadding = false
}: React.PropsWithChildren<IGenericSidebar>) => {
  const genericSidebarRef = useRef<HTMLDivElement>(null);
  useOutsideComponentClick(genericSidebarRef, onClose);
  return ReactDOM.createPortal(
    <div
      className={`generic-sidebar ${isOpen ? 'open' : 'closed'} ${position} ${removePadding ? '' : 'with-padding'}`}
      aria-expanded={isOpen}
      ref={genericSidebarRef}
    >
      <div className="generic-sidebar-header">
        <CloseIcon
          className={`generic-sidebar-icon ${position}`}
          onClick={onClose}
          aria-hidden={!isOpen}
          aria-label="Close sidebar"
        />
      </div>
      <div className="generic-sidebar-content">{children}</div>
    </div>,
    document.body
  );
};

export default GenericSidebar;
